export default Object.freeze({
  _SUCCESS: '_SUCCESS',
  _FAILURE: '_FAILURE'
});
